import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl }                       from '@angular/forms';

import { throwError }                                     from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { ToastrService }     from 'ngx-toastr';

import { PaymentPackage } from '@models/payment/payment-package';

import { ApiPaymentService } from '@services/api-payment.service';


@Component({
  selector:    'red-payment-package',
  templateUrl: './payment-package.component.html',
  styleUrls:   [ './payment-package.component.scss' ],
})
export class PaymentPackageComponent implements OnInit {

  private _discountedPackage: PaymentPackage;

  private set discountedPackage(value: PaymentPackage) {
    this._discountedPackage = value;
    this.activePackage      = value || this.package;
  }

  public activePackage: PaymentPackage;
  public couponControl: FormControl;

  @Input() public package:  PaymentPackage;

  @Output() public packageAction: EventEmitter<PaymentPackage>;
  @Output() public couponApplied: EventEmitter<string>;

  constructor(
    private formBuilder:    FormBuilder,
    private toastr:         ToastrService,
    private paymentService: ApiPaymentService,
  ) {
    this.packageAction = new EventEmitter<PaymentPackage>();
    this.couponApplied = new EventEmitter<string>();
  }

  ngOnInit(): void {
    this.couponControl = this.formBuilder.control('');

    this.couponControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    ).subscribe((value) => this.applyCoupon(value));

    this.discountedPackage = null;
  }

  private applyCoupon(coupon: string) {
    if (!coupon) {
      this.discountedPackage = null;
      return;
    }

    this.paymentService.getPackage(this.package.id, coupon).pipe(
      catchError((error) => this.handleCouponError(error))
    ).subscribe((response => {
      this.discountedPackage = response;
      this.couponAppliedAction(coupon);
    }));
  }

  private handleCouponError(error) {
    this.discountedPackage = null;
    this.couponAppliedAction(null);
    return throwError(error);
  }

  public couponAppliedAction(coupon: string) {
    if (coupon) {
      this.toastr.success(`Cupom ${ coupon } aplicado.`);
    }

    this.couponApplied.emit(coupon);
  }

  public action(paymentPackage: PaymentPackage, event?: Event) {
    if (event) event.preventDefault();
    this.packageAction.emit(paymentPackage);
  }
}
